import { useWorkspace } from '@/features/workspaces/hooks';
import { useGetWorkspaceMetricsQuery } from '@/services/endpoints/metrics';
import { FC, useMemo } from 'react';
import { HomeDataSectionChart } from '../../../common';
import { toAudienceChartDate } from './helpers';
import { HomeAudiencesChart, HomeAudiencesChartItem } from './HomeAudiencesChart';

export const HomeAudiencesChartWidget: FC = () => {
  const workspace = useWorkspace();
  const { data: metrics } = useGetWorkspaceMetricsQuery({ workspaceId: workspace.id });

  const data = useMemo<HomeAudiencesChartItem[]>(
    () =>
      Object.entries(metrics?.audienceSizeHistory ?? {})
        .map(([key, value]) => {
          return {
            ...toAudienceChartDate(key),
            value,
          };
        })
        .sort((a, b) => a.date.getTime() - b.date.getTime())
        .map((item) => ({
          name: item.label,
          value: +(item.value / 1000).toFixed(3),
        })),
    [metrics?.audienceSizeHistory]
  );

  return (
    <HomeDataSectionChart title='home:audienceChartTitle' subtitle='home:audienceChartSubtitle'>
      <div className='grid justify-items-end'>
        <HomeAudiencesChart data={data} />
      </div>
    </HomeDataSectionChart>
  );
};
